export default __webpack_public_path__ + "static/media/miscellaneous10.4a110fe3.png";